import { render, staticRenderFns } from "./p295_payment.vue?vue&type=template&id=eb3da13a"
import script from "./p295_payment.vue?vue&type=script&lang=js"
export * from "./p295_payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadioSelection: require('/root/containers/hermes_eshop/components/hyper/p295/radio_selection.vue').default,Panel: require('/root/containers/hermes_eshop/components/hyper/p295/panel.vue').default})
